export const en = {
  appName: "Rukousajat",
  tabs: {
    prayer: "Prayer",
    qiblah: "Qiblah",
    masjid: "Masjid",
    settings: "Settings",
    more: "More"
  },
  prayer: {
    nextPrayer: "Next Prayer",
    locating: "Determining your location...",
    now: "Now",
    fajr: "Fajr",
    sunrise: "Sunrise",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
    loading: "Loading…",
    nextPrayerIn: "Next prayer:",
    in: "in",
    today: "Today"
  },
  qiblah: {
    title: "Qiblah Finder",
    subtitle: "Rotate device to align markers",
    compass: "Compass",
    direction: "Direction",
    gettingLocation: "Getting your location…",
    locationPermissionRequired: "Location permission is required.",
    refresh: "Refresh"
  },
  masjid: {
    title: "Find a Masjid",
    placeholder: "Search address or city...",
    searching: "Searching Google Maps...",
    viewOnMaps: "View on Google Maps",
    noResults: "No results found nearby.",
    local: "Local",
    search: "Search"
  },
  settings: {
    title: "Settings",
    location: "Location",
    manual: "Manual Location",
    cityCountry: "Search city...",
    latitude: "Latitude",
    longitude: "Longitude",
    calc: "Calculation",
    calcMethod: "Calculation Method",
    asrMethod: "Asr Method",
    appearance: "Appearance",
    lang: "Language",
    theme: "Theme",
    system: "System",
    light: "Light",
    dark: "Dark",
    save: "Save",
    adhanEnabled: "Enable Adhan",
    persistentNotifications: "Persistent Notifications",
    ishaTime: "Isha Time",
    fajrTime: "Fajr Time",
    ishaDefault: "Default",
    fajrDefault: "Default",
    minAfterMaghrib: "Minutes after Maghrib",
    minBeforeSunrise: "Minutes before Sunrise",
    fixedTime: "Fixed Time",
    prayers: "Prayers",
    muslimWorldLeague: "Muslim World League",
    standard: "Standard"
  },
  more: {
    back: "Back",
    tasbih: "Tasbih",
    reset: "Reset",
    count: "Count",
    hijri: "Hijri Calendar",
    now: "Now",
    highlights: "Month Highlights",
    events: "Events & News",
    ramadan: "RAMADAN START",
    eid: "EID AL-ADHA",
    duas: "Daily Duas",
    kahf: "Surah Al-Kahf",
    listenFull: "LISTEN FULL SURAH",
    pause: "PAUSE",
    stats: "Prayer Stats",
    statsDesc: "Time intervals between daily prayer windows",
    fajrToMaghrib: "Fajr to Maghrib",
    dhuhrToAsr: "Dhuhr to Asr",
    sunriseToSunset: "Sunrise to Sunset",
    fajrToSunrise: "Fajr to Sunrise",
    maghribToIsha: "Maghrib to Isha",
    appInfo: "App Info",
    zakat: "Zakat Calculator",
    zakatDesc: "Calculate your Zakat (2.5% of wealth)",
    zakatTotal: "ZAKAT DUE",
    cashSavings: "Cash / Savings",
    goldValue: "Gold Value",
    silverValue: "Silver Value",
    nisabNote: "Ensure your wealth meets the Nisab threshold before paying Zakat",
    inheritance: "Inheritance Calculator",
    inheritanceDesc: "Calculate Islamic inheritance distribution",
    estateValue: "Estate Value",
    selectHeirs: "Select Heirs",
    heirHusband: "Husband",
    heirWife: "Wife",
    heirFather: "Father",
    heirMother: "Mother",
    heirSon: "Son",
    heirDaughter: "Daughter",
    distribution: "DISTRIBUTION",
    share: "share",
    disclaimer: "This is a simplified calculation. Consult a scholar for complex cases.",
    namesOfAllah: "99 Names of Allah",
    nameNumber: "NAME #",
    spiritualBenefit: "Spiritual Benefit",
    weekDays: ["S", "M", "T", "W", "T", "F", "S"],
    monthly: "Monthly Times",
    halalPlaces: "Halal Places",
    trains: "Trains",
    less: "Less",
    more: "More...",
    downloadApp: "Download Mobile App",
    adjustHijri: "Adjust Hijri Date",
    hijriCycle: "Hijri Cycle",
    year: "Year",
    thisYear: "This Year",
    tenYearOverview: "10-Year Overview",
    ayahs: "Ayahs",
    ayah: "AYAH",
    fetchingAyahs: "Fetching Ayahs...",
    morning: "Morning",
    evening: "Evening",
    prayerStatistics: "Prayer Statistics",
    prayerIntervals: "Prayer time intervals",
    daylightHours: "Daylight hours",
    afternoonPeriod: "Afternoon period",
    fullDaylight: "Full daylight",
    dawnPeriod: "Dawn period",
    eveningPeriod: "Evening period",
    errorLoading: "Error loading statistics",
    loadingStats: "Loading statistics...",
    sons: "Sons",
    daughters: "Daughters",
    searchHalal: "Search halal places",
    searching: "Searching...",
    noResults: "No results found",
    viewOnMaps: "View on Maps",
    selectStation: "Select Station",
    favorites: "Favorites",
    useCurrentLocation: "Use Current Location",
    refresh: "Refresh",
    loading: "Loading...",
    dataSource: "Data from Liikennevirasto Digital API. Licensed under Creative Commons Attribution 4.0",
    appVersion: "Version",
    appDescription: "Prayer times and Islamic utilities for Finland"
  },
  trains: {
    useCurrentLocation: "My Location",
    selectStation: "Select Station",
    noTrainsFound: "No trains found",
    time: "Time",
    track: "Track",
    train: "Train",
    destination: "Destination",
    cancelled: "Cancelled"
  },
  ramadan: {
    title: "Ramadan 2026",
    expected: "Expected:",
    date: "18-19 Feb",
    daysLeft: "days left",
    today: "Today!",
    fastingHours: "Fasting Hours"
  }
};
